import { render } from "./BaseErrorMessage.vue?vue&type=template&id=020c1f45&scoped=true"
import script from "./BaseErrorMessage.vue?vue&type=script&lang=js"
export * from "./BaseErrorMessage.vue?vue&type=script&lang=js"

import "./BaseErrorMessage.vue?vue&type=style&index=0&id=020c1f45&scoped=true&lang=css"

import exportComponent from "C:\\Git\\whistleblowing_FE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020c1f45"]])

export default __exports__